// @flow

import React, { type Node, useMemo } from  'react';
import { Cell, Title, Value, ValueSmall, ValueSeparator } from './ticket';
import { usePendingIncomingPayment, getSafeDueDate, getCountry } from '@tectonics/prs/incoming-payment';
import { formatDueDate } from '@tectonics/prs/voucher';
import { getWeekDay } from '@tectonics/prs/week-day';

export function VoucherTicketDueDate(): Node {
  return (
    <Cell>
      <Title>
        <TitleContent />
      </Title>

      <Value>
        <DueDateContent />
        <ValueSeparator />
        <ValueSmall>
          <DueDateWeekDay />
        </ValueSmall>
      </Value>
    </Cell>
  );
}

function TitleContent(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'mx':
      return 'Vencimiento';

    default:
      throw new Error('Voucher Ticket Due Date Title - Not implemented yet');
  }
}

function DueDateContent(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'mx':
      return formatDueDate(getSafeDueDate(incomingPayment));

    default:
      throw new Error('Voucher Ticket Due Date Content - Not implemented yet');
  }
}

function DueDateWeekDay(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const dueDate = getSafeDueDate(incomingPayment);
  const weekDay = useMemo(() => getWeekDay(dueDate, WEEK_DAYS), [dueDate]);

  switch (country) {
    case 'mx':
      return weekDay;

    default:
      throw new Error('Voucher Ticket Due Date Week Day - Not implemented yet');
  }
}

const WEEK_DAYS = [
  'lun.',
  'lun.',
  'mar.',
  'mié.',
  'jue.',
  'vie.',
  'lun.',
];
